import { downgradeInjectable } from "@angular/upgrade/static";
import { ArrayToStringPipe } from "@nms-ng2/app/shared/pipes/array/array-to-string.pipe";
import { StringOrNumber, StringOrNumberArray, WrapInArrayPipe } from "@nms-ng2/app/shared/pipes/array/wrap-in-array.pipe";
import { FormatStringPipe } from "@nms-ng2/app/shared/pipes/format-string.pipe";
import { ZabbixUrlFormatterPipe } from "@nms-ng2/app/shared/pipes/zabbix-url-formatter.pipe";
import { ToArrayPipe } from "@nms-ng2/app/shared/pipes/array/to-array.pipe";
import { CleanLineBreakPipe } from "@nms-ng2/app/shared/pipes/clean-line-break.pipe";
import { AlphanumPipe } from "@nms-ng2/app/shared/pipes/alpha-num.pipe";
import { ReplaceLineBreakPipe } from "@nms-ng2/app/shared/pipes/replace-line-break.pipe";
import { BytesFormatterPipe } from "@nms-ng2/app/shared/pipes/bytes-formatter.pipe";
import { PacketsFormatterPipe } from "@nms-ng2/app/shared/pipes/packets-formatter.pipe";
import { FirmwareRangeRulePipe } from "@nms-ng2/app/shared/pipes/firmware-range-rule-filter.pipe";
import { ReplaceTabPipe } from "@nms-ng2/app/shared/pipes/replace-tab.pipe";
import { DateFormatPipe } from "@nms-ng2/app/shared/pipes/date-format.pipe";
import { NodeIdentifierPipe } from "@nms-ng2/app/shared/pipes/node-identifier.pipe";
import { NumericRangeFormatterPipe } from "@nms-ng2/app/shared/pipes/numeric-range-formatter.pipe";
import { FileNameGeneratorPipe } from "@nms-ng2/app/shared/pipes/file-name-generator.pipe";
import { RemoveLineBreakPipe } from "@nms-ng2/app/shared/pipes/string/remove-html-line-break.pipe";
import {
    EscapeTagsExceptLineAndThematicBreakPipe
} from "@nms-ng2/app/shared/pipes/escape-tags-except-line-and-thematic-break.pipe";
import { CutStringPipe } from "@nms-ng2/app/shared/pipes/cut-string.pipe";
import { OrderByNumbersAndLettersPipe } from "@nms-ng2/app/shared/pipes/order-by-numbers-and-letters.pipe";


/**
 * Classe responsável por realizar o downgrade dos pipes do angular 9 para o angularjs.
 */
const app = angular.module("nms.downgraded.filters", []);

app.factory("arrayToStringPipe", downgradeInjectable(ArrayToStringPipe));
app.filter("arrayToString", ["arrayToStringPipe",
        (arrayToStringPipe: ArrayToStringPipe) => (input: string[], shouldBreakLine = false) =>
            arrayToStringPipe.transform(input, shouldBreakLine)
]);

app.factory("zabbixUrlFormatterPipe", downgradeInjectable(ZabbixUrlFormatterPipe));
app.filter("zabbixUrlFormatter", ["zabbixUrlFormatterPipe",
        (zabbixUrlFormatter: ZabbixUrlFormatterPipe) => (link: string, itemId: string) =>
            zabbixUrlFormatter.transform(link, itemId)
]);

app.factory("formatStringPipe", downgradeInjectable(FormatStringPipe));
app.filter("formatString", ["formatStringPipe",
        (formatString: FormatStringPipe) => (message: string, params: string[]) => formatString.transform(message, params)
]);

app.factory("wrapInArrayPipe", downgradeInjectable(WrapInArrayPipe));
app.filter("wrapInArray", ["wrapInArrayPipe",
    (wrapInArrayPipe: WrapInArrayPipe) => (input: StringOrNumber | StringOrNumberArray) => wrapInArrayPipe.transform(input)
]);

app.factory("toArrayPipe", downgradeInjectable(ToArrayPipe));
app.filter("toArray", ["toArrayPipe",
    (toArrayPipe: ToArrayPipe) => (input: any) => toArrayPipe.transform(input)
]);

app.factory("cleanLineBreakPipe", downgradeInjectable(CleanLineBreakPipe));
app.filter("cleanLineBreak", ["cleanLineBreakPipe",
    (cleanLineBreakPipe: CleanLineBreakPipe) => (value) => cleanLineBreakPipe.transform(value)
]);

app.factory("alphanumPipe", downgradeInjectable(AlphanumPipe));
app.filter("alphanum", ["alphanumPipe",
    (alphanumPipe: AlphanumPipe) =>
        (a: string, b: string, caseInsensitive = false) => alphanumPipe.transform(a, b, caseInsensitive)
]);

app.factory("replaceLineBreakPipe", downgradeInjectable(ReplaceLineBreakPipe));
app.filter("replaceLineBreak", ["replaceLineBreakPipe",
    (replaceLineBreakPipe: ReplaceLineBreakPipe) => (value) => replaceLineBreakPipe.transform(value)
]);

app.factory("bytesFormatterPipe", downgradeInjectable(BytesFormatterPipe));
app.filter("bytesFormatter", ["bytesFormatterPipe",
    (bytesFormatterPipe: BytesFormatterPipe) => (bytes: number) => bytesFormatterPipe.transform(bytes)
]);

app.factory("packetsFormatterPipe", downgradeInjectable(PacketsFormatterPipe));
app.filter("packetsFormatter", ["packetsFormatterPipe",
    (packetsFormatterPipe: PacketsFormatterPipe) => (packets: number) => packetsFormatterPipe.transform(packets)
]);

app.factory("firmwareRangeRulePipe", downgradeInjectable(FirmwareRangeRulePipe));
app.filter("firmwareRangeRule", ["firmwareRangeRulePipe",
    (firmwareRangeRulePipe: FirmwareRangeRulePipe) => (value) => firmwareRangeRulePipe.transform(value)
]);

app.factory("replaceTabPipe", downgradeInjectable(ReplaceTabPipe));
app.filter("replaceTab", ["replaceTabPipe",
    (replaceTabPipe: ReplaceTabPipe) => (input: string) => replaceTabPipe.transform(input)
]);

app.factory("dateFormatPipe", downgradeInjectable(DateFormatPipe));
app.filter("dateFormat", ["dateFormatPipe",
    (dateFormatPipe: DateFormatPipe) => (date: Date | string | number) => dateFormatPipe.transform(date)
]);

app.factory("nodeIdentifierPipe", downgradeInjectable(NodeIdentifierPipe));
app.filter("nodeIdentifier", ["nodeIdentifierPipe",
    (nodeIdentifierPipe: NodeIdentifierPipe) => (node, data) => nodeIdentifierPipe.transform(node, data)
]);

app.factory("numericRangeFormatterPipe", downgradeInjectable(NumericRangeFormatterPipe));
app.filter("numericRangeFormatter", ["numericRangeFormatterPipe",
    (numericRangeFormatterPipe: NumericRangeFormatterPipe) =>
        (numbersArray: Array<any>) => numericRangeFormatterPipe.transform(numbersArray)
]);

app.factory("fileNameGeneratorPipe", downgradeInjectable(FileNameGeneratorPipe));
app.filter("fileNameGenerator", ["fileNameGeneratorPipe",
    (fileNameGeneratorPipe: FileNameGeneratorPipe) => (fileNamePrefix: string, extension: string) =>
        fileNameGeneratorPipe.transform(fileNamePrefix, extension)
]);

app.factory("removeLineBreakPipe", downgradeInjectable(RemoveLineBreakPipe));
app.filter("removeLineBreak", ["removeLineBreakPipe",
    (removeLineBreakPipe: RemoveLineBreakPipe) =>
        (input: string) => removeLineBreakPipe.transform(input)
]);

app.factory("escapeTagsExceptLineAndThematicBreakPipe", downgradeInjectable(EscapeTagsExceptLineAndThematicBreakPipe));
app.filter("escapeTagsExceptLineAndThematicBreak", ["escapeTagsExceptLineAndThematicBreakPipe",
    (escapeTags: EscapeTagsExceptLineAndThematicBreakPipe) => (input) => escapeTags.transform(input)
]);

app.factory("cutStringPipe", downgradeInjectable(CutStringPipe));
app.filter("cutString", ["cutStringPipe",
    (cutStringPipe: CutStringPipe) => (input: string, maxChars: number) => cutStringPipe.transform(input, maxChars)
]);

app.factory("orderByNumbersAndLettersPipe", downgradeInjectable(OrderByNumbersAndLettersPipe));
app.filter("orderByNumbersAndLetters", ["orderByNumbersAndLettersPipe",
    (orderByNumbersAndLettersPipe: OrderByNumbersAndLettersPipe) =>
        (items: Array<string | number>, caseInsensitive: boolean) =>
            orderByNumbersAndLettersPipe.transform(items, caseInsensitive)
]);
